import * as React from "react";

export default class CreateEvents extends React.Component {

	render(){
		return (
			<h1>Veranstaltung erstellen!</h1>
		)
	}
}